import React from 'react';
import UserListDropDown from '../userList/UserListDropDown';
import PropTypes from 'prop-types';
import { IconButton, Stack } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';

export default function UserNavigation({ user, onClickHelp }) {
    return (
        <Stack direction="row" gap={2} justifyContent="center" alignItems="center">
            <IconButton onClick={onClickHelp} sx={{ color: 'white' }}>
                <HelpIcon />
            </IconButton>
            <Stack paddingRight={1.5}>
                <UserListDropDown user={user} />
            </Stack>
        </Stack>
    );
}

UserNavigation.propTypes = {
    user: PropTypes.object,
    onClickHelp: PropTypes.func,
};
